module.exports = __webpack_public_path__ + "img/readBtn.36a5aa49.png";